// Get section settings from the DOM
let deliveryCountdown = document.getElementById("delivery-countdown");

let activateTimer = deliveryCountdown.getAttribute("data-activate-timer");
let hours = deliveryCountdown.getAttribute("data-hour");
let minutes = deliveryCountdown.getAttribute("data-minute");
let averageShippingTime = deliveryCountdown.getAttribute("data-delivery-estimate");
let deliveryText = deliveryCountdown.getAttribute("data-delivery-text");

let monday = deliveryCountdown.getAttribute("data-monday");
let tuesday = deliveryCountdown.getAttribute("data-tuesday");
let wednesday = deliveryCountdown.getAttribute("data-wednesday");
let thursday = deliveryCountdown.getAttribute("data-thursday");
let friday = deliveryCountdown.getAttribute("data-friday");
let saturday = deliveryCountdown.getAttribute("data-saturday");
let sunday = deliveryCountdown.getAttribute("data-sunday");
let shippingDays = [sunday, monday, tuesday, wednesday, thursday, friday, saturday];


let excludedDays = deliveryCountdown.getAttribute("data-excluded-dates");
let excludedDatesArray = [excludedDays]
if(excludedDatesArray.includes(',')){
    excludedDatesArray = excludedDays.split(',');
}

let shippingDayCounter = 0;
let checkedDays = 1; //This should be 0 if same day delivery
var estimatedDeliveryDate = getEstimatedDeliveryDate();

function formatDate(dateString) {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    // Parsing the date string
    const parts = dateString.split('-');
    const day = parseInt(parts[0]);
    const monthIndex = parseInt(parts[1]) - 1; // Adjusting month index
    const year = parseInt(parts[2]);

    // Getting the day suffix (st, nd, rd, or th)
    let daySuffix;
    if (day === 1 || day === 21 || day === 31) {
        daySuffix = 'st';
    } else if (day === 2 || day === 22) {
        daySuffix = 'nd';
    } else if (day === 3 || day === 23) {
        daySuffix = 'rd';
    } else {
        daySuffix = 'th';
    }

    // Formatting the date
    const formattedDate = `${months[monthIndex]} ${day}${daySuffix}`;

    // Getting the day of the week
    const dateObj = new Date(year, monthIndex, day);
    const dayOfWeek = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'][dateObj.getDay()];

    return `${dayOfWeek} ${formattedDate}`;
}

function getDateXDaysInFuture(days) {
	const currentDate = new Date();
	const futureDate = new Date(currentDate.getTime() + days * 24 * 60 * 60 * 1000); // Convert days to milliseconds and add to current date

	const day = String(futureDate.getDate()).padStart(2, '0');
	const month = String(futureDate.getMonth() + 1).padStart(2, '0'); // January is 0
	const year = futureDate.getFullYear();
	const dayOfWeek = futureDate.getDay(); // Get day of the week

	return `${day}-${month}-${year}, ${dayOfWeek}`;
}

function getEstimatedDeliveryDate(){
    const now = new Date();
    
    // Retrieve the cut-off hour dynamically from the data attribute
    const cutOffHour = parseInt(deliveryCountdown.getAttribute("data-hour"));
    const currentHour = now.getHours();

    // If current time is after the cut-off time, start checking from the day after next
    if (currentHour >= cutOffHour) {
        checkedDays = 2; // Day after next
    } else {
        checkedDays = 1; // Next day
    }

    for (shippingDayCounter; shippingDayCounter < averageShippingTime; checkedDays++) {
        let checkingDate = getDateXDaysInFuture(checkedDays).split(',')[0];
        let dayOfWeek = getDateXDaysInFuture(checkedDays).split(',')[1];

        if (shippingDays[parseInt(dayOfWeek)]) {
            let isExcluded = false;
            excludedDatesArray.forEach(function(dateString) {
                if (dateString.length > 0) {
                    if (checkingDate.includes(dateString.trim())) {
                        isExcluded = true;
                    }
                }
            });
            if (!isExcluded) {
                shippingDayCounter++;
            }
        }

        if (shippingDayCounter == averageShippingTime) {
            checkedDays = 1;
            shippingDayCounter = 0;
            return checkingDate;
        }
    }
}

function timeUntilX(hours, minutes) {
    var now = new Date();
    var target = new Date(now);

    // Set the target time for today
    target.setHours(hours);
    target.setMinutes(minutes);
    target.setSeconds(0);
    target.setMilliseconds(0);

    // If target time is already passed for today, set it for tomorrow
    if (target <= now) {
        target.setDate(target.getDate() + 1);
    }

    // Calculate the difference in milliseconds between now and the target time
    var difference = target.getTime() - now.getTime();

    // Convert milliseconds difference to hours, minutes, and seconds
    var hoursUntilX = Math.floor(difference / (1000 * 60 * 60));
    var minutesUntilX = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    var secondsUntilX = Math.floor((difference % (1000 * 60)) / 1000);

    return {
        hours: hoursUntilX,
        minutes: minutesUntilX,
        seconds: secondsUntilX
    };
}

// Function to update the countdown timer
function updateClock() {
    var time = timeUntilX(hours,minutes);
    var countdown = document.getElementById('delivery-countdown');
    countdown.innerHTML = '<div class="timer-container"><div class="time">'+ deliveryText + '</div></div>' +
                        '<div class="timer-wrapper">' +
                            '<div class="timer-value hours">'+ (time.hours < 10 ? '0' : '') + time.hours + '<span>h</span>' + '</div>' +
                            '<div class="timer-value minutes">' + (time.minutes < 10 ? '0' : '') + time.minutes + '<span>m</span>' + '</div>' +
                            '<div class="timer-value seconds">' + (time.seconds < 10 ? '0' : '') + time.seconds + '<span>s</span>' + '</div>'
                        '</div>';

    if (time.total <= 0) {
        clearInterval(timeinterval);
    }
}

document.addEventListener('DOMContentLoaded', function() {
    if(activateTimer){
        // Update the timer every second
        var timeinterval = setInterval(updateClock, 1000);
    }
});